import { TableCard } from 'app/components'
import { ProfissionalValoresListHeader } from './components/header/ProfissionalValoresListHeader'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ProfissionalValoresTable } from './table/ProfissionalValoresTable'

const ProfissionalValoresList = () => {
  return (
    <TableCard>
      <ProfissionalValoresListHeader />
      <ProfissionalValoresTable />
    </TableCard>
  )
}

export const ProfissionalValoresListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ProfissionalValoresList />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
